




















import Vue from "vue";

type TooltipDirection = "left" | "right" | "top" | "bottom";

interface Data {
  isVisible: boolean;
}

interface Props {
  direction: TooltipDirection;
  open: boolean;
}

export default Vue.extend<Data, {}, {}, Props>({
  name: "JzTooltip",

  props: {
    direction: { type: String as () => TooltipDirection, default: "top" },
    open: { type: Boolean, default: false }
  },
  watch: {
    open: {
      handler(newVal: boolean) {
        const emitEvent = newVal ? "tooltip-shown" : "tooltip-hidden";
        this.$emit(emitEvent);
      },
      immediate: false
    }
  }
});
